// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"240":"cd5518ab","673":"cd5518ab"}[chunkId] + ".chunk.css";
};